import { gql } from '@apollo/client';

export interface MemberTraits {
  hasApplications?: boolean | null;
  hasApprovedApplications?: boolean | null;
  hasBachelorsWarning?: boolean | null;
  hasBookmarks?: boolean | null;
  hasCoachRecommendations?: boolean | null;
  hasCompletedApplications?: boolean | null;
  hasDeferredApplications?: boolean | null;
  hasQuizRecommendations?: boolean | null;
  hasReferrals?: boolean | null;
  hasStartedApplications?: boolean | null;
  isCurrentlyEnrolled?: boolean | null;
  isCurrentlyEnrolledInEcornell?: boolean | null;
  isTransitionMember?: boolean | null;
  isUnsureAboutNextStep?: boolean | null;
  transitionProgram?: TransitionProgram;
  userUuid?: string;
}

interface TransitionProgram {
  programName?: string;
  programUuid?: string;
  academicPartner?: string;
  fundingLevel?: string;
}

export interface MemberTraitsResponse {
  traits: MemberTraits;
}

export interface MemberTraitsVariables {
  studentUuid: string | undefined;
}

export const ALL_MEMBER_TRAITS_QUERY = gql`
  query MEMBER_TRAITS_QUERY($studentUuid: ID!) {
    traits: getTraits(studentUuid: $studentUuid) {
      hasApplications
      hasApprovedApplications
      hasBachelorsWarning
      hasBookmarks
      hasCoachRecommendations
      hasCompletedApplications
      hasDeferredApplications
      hasQuizRecommendations
      hasReferrals
      hasStartedApplications
      isCurrentlyEnrolled
      isCurrentlyEnrolledInEcornell
      isTransitionMember
      isUnsureAboutNextStep
      transitionProgram {
        academicPartner
        fundingLevel
        programName
        programUuid
      }
    }
  }
`;
